import { IsOptional, IsArray } from "class-validator";
import { ICourseDogSessions } from "./course-dog-sessions.interface";

export class CourseDogSessionsDto implements ICourseDogSessions {
  //
  @IsOptional() // Optional for seminars
  dog_id?: string;

  @IsOptional()
  @IsArray()
  session_ids?: string[];
}
